/**
 * @desc 内容超出启用提示
 */
export default {
  data () {
    return {
      tipsDisabled: true
    }
  },
  methods: {
    /**
     * @desc 内容超出显示提示
     * @param {Object} {e} //事件对象
     */
    mouseOverShowTips (e) {
      let clientWidth = e.target.clientWidth
      let scrollWidth = e.target.scrollWidth
      this.tipsDisabled = scrollWidth > clientWidth ? false : true
    }
  }
}